import React from 'react';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import AggregationBuilder from 'src/components/BeaconV2Components/utils/AggregationBuilder';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import { useMainTimePeriodShortDisplayName, useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks';
import { useMainEntityType, useProductEntity } from 'src/utils/Hooks/reduxSelectors';

const aggregationBuilder = (aggBuilder: AggregationBuilder): AggregationBuilder => {
  return aggBuilder.clearConditionRangeFilters().addConditionRangeFilter('organicClicks', 1);
};
export default function KeywordsWithOrganicTrafficSplineChart() {
  const title = shouldShowBeaconProTopics() ? 'Keyword Count with Organic Traffic' : 'Keywords with Organic Traffic';
  const mainEntityType = useMainEntityType();
  const mainPeriodDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonDisplayName = useComparisonTimePeriodShortDisplayName();
  const { isProductEntity } = useProductEntity();
  const isCategoryEntity = mainEntityType === 'category';
  const isSubcategoryEntity = mainEntityType === 'subcategory';
  const titleOnly = !(isProductEntity || isCategoryEntity || isSubcategoryEntity);
  const entityPhrase = useEntityPhrasing({ titleOnly });
  const taxonomyText = useTaxonomySubtitleText();
  const getSubtitle = () => {
    return (
      <BeaconSubtitleContainer>
        <Text variant="body1">
          {`The chart displays the unique number of keywords that generated organic traffic for ${entityPhrase}`}
          {taxonomyText}
          {` during the ${mainPeriodDisplayName} period compared to the ${comparisonDisplayName}.`}
          <SubtitleFilters />
        </Text>
      </BeaconSubtitleContainer>
    );
  };

  return (
    <BeaconComparableSplineChart
      beaconChartWithLegendOverride={
        shouldShowBeaconProTopics()
          ? (props) => {
              return {
                ...props,
                includeSummaryInfo: false,
                subtitle: getSubtitle()
              };
            }
          : undefined
      }
      title={title}
      indexName="traffic"
      fieldName="searchTerm"
      primaryAggregationBuilder={aggregationBuilder}
      secondaryAggregationBuilder={aggregationBuilder}
    />
  );
}
